// @Packages
import React from 'react';
import { ListItem, useTheme } from '@rneui/themed';
import { Pressable } from 'react-native';

// @styles
import IconComponent from '../../atoms/icon';
import useStyles from './styles';
import { EStatus, ISession } from '../../../utils/types';

interface Props {
  session?: ISession;
  onPress?: (item: any) => void;
  title: string;
}

const ListItemComponent = ({
  title,
  session,
  onPress
}: Props) => {
  const styles = useStyles();
  const { theme } = useTheme();

  const isCustomerStrategy = session?.strategy_id === 1
  const hasSession = (session != null) && !isCustomerStrategy
  const status = session?.session_status ?? session?.status;
  const hasSessionIcon = status === EStatus.ACTIVE
    ? <IconComponent.MaterialCommunityIcon name="robot-outline" color={theme.colors.success} size={22} />
    : <IconComponent.MaterialCommunityIcon name="robot-outline" color="black" size={22} />;
  const icon = hasSession
    ? hasSessionIcon
    : <IconComponent.FeatherIcon name="calendar" color={theme.colors.grey1} size={22} />;

  return (
    <Pressable onPress={onPress}>
      <ListItem
        containerStyle={styles.container}
        onPress={onPress}
        style={styles.mainContainer}
        bottomDivider
      >
        <ListItem.Content style={styles.content}>
          <IconComponent dark={!false}>
            {icon}
          </IconComponent>
          <ListItem.Title style={styles.title}>{title}</ListItem.Title>
        </ListItem.Content>
        <ListItem.Chevron color="black" />
      </ListItem>
    </Pressable>
  );
};

ListItemComponent.defaultProps = {
  onPress: Function.prototype
};

export default ListItemComponent;
